import { css } from "lit";

export const holloEmbedStyles = css`
  :host {
    position: fixed;
    bottom: 20px;
    right: 20px;
    /* Use extremely high z-index to sit above host page UI */
    z-index: 2147483647;
    font-family: "Segoe UI", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  }

  @media (max-width: 460px) {
    :host {
      bottom: 10px;
    }
  }

  /* Desktop width, adjust popup for shorter viewport heights */
  @media (min-width: 461px) and (max-height: 900px) {
    .hollo-popup {
      height: 520px;
      max-height: 85dvh !important;
    }
  }
  @media (min-width: 461px) and (max-height: 750px) {
    .hollo-popup {
      height: 460px;
      max-height: 80dvh !important;
    }
  }
  @media (min-width: 461px) and (max-height: 650px) {
    .hollo-popup {
      height: 420px;
      max-height: 75dvh !important;
    }
  }

  .hollo-widget {
    position: relative;
  }

  .hollo-trigger {
    width: 74px;
    height: 74px;
    border: none;
    border-radius: 999px;
    font-size: 22px;
    cursor: pointer;
    box-shadow: 0 10px 30px rgba(79, 70, 229, 0.35);
    padding: 0;
    z-index: inherit;
  }

  .hollo-popup {
    position: absolute;
    bottom: calc(100% + 12px);
    right: 0;
    width: 380px;
    max-width: 90vw;
    height: 600px;
    max-height: 85dvh;
    background: #fff;
    border-radius: 20px;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    animation: hollo-slideUp 0.28s ease-out;
    z-index: inherit;
  }

  /* Nudge tooltip above the trigger */
  .hollo-nudge {
    position: absolute;
    right: 0;
    bottom: 76px; /* 64px trigger + 12px gap */
    width: 240px;
    background: rgb(7, 28, 26);
    color: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    line-height: 1.2;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px;
    animation: hollo-slideUp 0.25s ease-out;
  }
  .hollo-nudge-text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .hollo-nudge-dismiss {
    background: transparent;
    border: none;
    color: #e5e7eb;
    cursor: pointer;
    font-size: 14px;
    padding: 2px 4px;
    border-radius: 6px;
  }
  .hollo-nudge-dismiss:hover {
    background: rgba(255, 255, 255, 0.08);
  }
  .hollo-nudge-arrow {
    position: absolute;
    right: 18px;
    bottom: -6px;
    width: 12px;
    height: 12px;
    background: #111827;
    transform: rotate(45deg);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
  }

  .hollo-content {
    flex: 1;
    overflow: auto;
    padding: 0px 8px 8px 8px;
    background: #fff;
    border: none;
    border-bottom: none;

    /* Custom scrollbar styles */
    --sb-track-color: #ffffff;
    --sb-thumb-color: #d1d5db;
    --sb-size: 3px;
  }

  /* Prevent scrolling when error panel is shown */
  .hollo-content:has(.hollo-error-panel) {
    overflow: hidden;
  }

  @media (max-width: 460px) {
    .hollo-content {
      padding: 0px 8px 8px 8px;
    }
  }

  .hollo-content::-webkit-scrollbar {
    width: var(--sb-size);
  }

  .hollo-content::-webkit-scrollbar-track {
    background: var(--sb-track-color);
    border-radius: 3px;
  }

  .hollo-content::-webkit-scrollbar-thumb {
    background: var(--sb-thumb-color);
    border-radius: 3px;
  }

  @supports not selector(::-webkit-scrollbar) {
    .hollo-content {
      scrollbar-color: var(--sb-thumb-color) var(--sb-track-color);
    }
  }

  .hollo-spinner-wrap {
    height: 100%;
    display: grid;
    gap: 10px;
    place-items: center;
    color: #111827;
  }
  .hollo-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e5e7eb;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: hollo-spin 0.9s linear infinite;
  }
  .hollo-spinner-text {
    font-size: 13px;
    color: #6b7280;
  }

  .hollo-conn-banner {
    margin: 6px 16px 0;
    padding: 8px 10px;
    border-radius: 10px;
    font-size: 12px;
    color: #92400e;
    background: #fffbeb;
    border: 1px solid #fbbf24;
  }
  .hollo-conn-banner.hollo-conn-banner--error {
    color: #7f1d1d;
    background: #fee2e2;
    border-color: #ef4444;
  }

  .hollo-error-panel {
    height: 100%;
    min-height: 0;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #111827;
    padding: 40px 24px;
    gap: 0;
    box-sizing: border-box;
    overflow: hidden;
  }
  .hollo-error-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    margin-bottom: 24px;
    background: #fef2f2;
    border-radius: 50%;
    flex-shrink: 0;
  }
  .hollo-error-icon-wrapper svg {
    color: #ef4444;
  }
  .hollo-error-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 400px;
  }
  .hollo-error-title {
    font-weight: 700;
    font-size: 22px;
    line-height: 1.3;
    color: #111827;
    margin: 0;
    letter-spacing: -0.02em;
  }
  .hollo-error-desc {
    font-size: 15px;
    line-height: 1.6;
    color: #6b7280;
    margin: 0;
    font-weight: 400;
  }

  .hollo-toast-container {
    position: absolute;
    top: 60px;
    left: 12px;
    right: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    z-index: 1000;
    pointer-events: none;
  }

  .hollo-toast {
    pointer-events: auto;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 14px;
    padding: 10px 14px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    gap: 12px;
    animation: hollo-toast-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.2)
      forwards;
    max-width: 100%;
    margin: 0 auto;
    width: fit-content;
    min-width: 200px;
  }

  .hollo-toast-icon {
    font-size: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .hollo-toast-content {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }

  .hollo-toast-text {
    font-size: 13px;
    font-weight: 500;
    color: #1f2937;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .hollo-toast-count {
    font-size: 11px;
    background: rgba(0, 0, 0, 0.05);
    padding: 1px 6px;
    border-radius: 10px;
    color: #6b7280;
    font-weight: 600;
  }

  .hollo-toast-close {
    background: transparent;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    padding: 4px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .hollo-toast-close:hover {
    background: rgba(0, 0, 0, 0.05);
    color: #4b5563;
  }

  .hollo-toast.hollo-toast--warning {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--warning .hollo-toast-icon {
    background: transparent;
  }

  .hollo-toast.hollo-toast--error {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--error .hollo-toast-icon {
    background: transparent;
  }

  .hollo-toast.hollo-toast--success {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid rgba(0, 0, 0, 0.1);
  }

  .hollo-toast.hollo-toast--success .hollo-toast-icon {
    background: transparent;
  }

  @keyframes hollo-toast-in {
    from {
      transform: translateY(-20px) scale(0.9);
      opacity: 0;
    }
    to {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
  }

  @keyframes hollo-slideUp {
    from {
      transform: translateY(12px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  @keyframes hollo-spin {
    to {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 460px) {
    .hollo-popup {
      width: 100vw;
      max-width: 100vw;
      right: -20px;
      height: 100dvh;
      max-height: 100dvh;
      bottom: -10px;
      border-radius: 0;
    }
  }
`;
